import { memo } from "react";
import { Box, Link, Typography } from "@mui/material";

const Footer = memo(({ sx = {} }) => {

    return (
        <Box
            sx={{
                height: "55px", display: "flex",
                flexDirection: "column", gap: "2px",
                justifyContent: "center",
                ...sx
            }}
        >
            <Typography variant="caption" color={"rgb(0, 0, 0)"} fontWeight={900}>
                ©️ 2025 <Link href="https://bildungsakademie-deutschland.com/" target="_blank">bildungsakademie-deutschland.com</Link> . All Rights Reserved. | <Link href="https://akademio-digital.de/datenschutz/" target="_blank">Datenschutz</Link> | <Link href="https://akademio-digital.de/impressum/" target="_blank">Impressum</Link>
            </Typography>
            <Typography variant="caption" color={"rgb(0, 0, 0)"} fontWeight={900}>
                ❤️ Webdesign & Developed by <Link href="https://pb-infotech.de/" target="_blank">PB Infotech.</Link>
            </Typography>
        </Box>
    );
});

export default Footer;